



















import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'DialogMessage',

  props: {
    dialogMessage: Boolean,
    dialogTitle: String,
    dialogText: String,
  }
})
